// extracted by mini-css-extract-plugin
export default {"mysticTextContainer":"MysticText_mysticTextContainer__iCZ1n","mysticText":"MysticText_mysticText__Fu3HR"};